import React, { FC, memo } from "react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { Header } from "../Header";

interface HeaderProps {
  readonly title: string;
  readonly onBack: (() => void) | undefined;
  readonly onPressWishlist: (() => void) | undefined;
}

const BasketHeader: FC<HeaderProps> = ({ onBack, onPressWishlist, title }) => (
  <Header testID="basket-header">
    <ButtonIcon name="arrow_left" testID="arrow-left-button-icon" onPress={onBack} />
    <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
      {title}
    </Text>
    <ButtonIcon name="heart" onPress={onPressWishlist} />
  </Header>
);

const MemoizedBasketHeader = memo(BasketHeader);

export { MemoizedBasketHeader as BasketHeader };
